import React from "react";
import TextButton from "../../../templates/component/buttons/textButton";

const ConstantvalueAddButton = () =>{

    return(
        <>
            <TextButton />

        </>
    )
}

export default ConstantvalueAddButton;